import { render, staticRenderFns } from "./DMCA.vue?vue&type=template&id=0cfe9302&scoped=true&"
import script from "./DMCA.vue?vue&type=script&lang=js&"
export * from "./DMCA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfe9302",
  null
  
)

export default component.exports